import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaTrophy, FaUsers, FaFutbol, FaMoneyBill, FaGift, FaCopy, FaShareAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { AuthContext } from '../contexts/AuthContext';
import { useToast } from '../components/Shared/Toast';

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const { success, error } = useToast();

  const referralLink = user?.referralLink || `${window.location.origin}/register?ref=${user?.referralCode || ''}`;

  const copyReferralLink = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      success('Link Copied', 'Referral link clipboard me copy ho gaya.');
    } catch (copyError) {
      error('Copy Failed', 'Referral link copy nahi ho saka.');
    }
  };

  const shareReferralLink = async () => {
    if (!navigator.share) {
      copyReferralLink();
      return;
    }

    try {
      await navigator.share({
        title: 'Join Ideal11',
        text: 'Ideal11 join karo is referral link se.',
        url: referralLink
      });
    } catch (shareError) {
      // User cancellation ko silently ignore karte hain.
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="container mx-auto px-4 py-10 min-h-screen"
    >
      <h1 className="text-4xl font-extrabold text-gray-900 mb-8 text-center">Dashboard</h1>
      {user?.referralCode && (
        <div className="mb-8 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-6 shadow-sm">
          <div className="flex items-start justify-between gap-4 flex-col sm:flex-row">
            <div>
              <p className="text-sm font-semibold uppercase tracking-wide text-amber-700">Referral Program</p>
              <h2 className="text-2xl font-bold text-gray-900 mt-1">Share your code and earn Rs 25 per user</h2>
              <p className="text-gray-600 mt-2">
                Your code: <span className="font-bold text-amber-700">{user.referralCode}</span>
              </p>
              <p className="text-sm text-gray-500 mt-2 break-all">{referralLink}</p>
              <div className="flex flex-wrap gap-3 mt-4">
                <button
                  onClick={copyReferralLink}
                  className="inline-flex items-center rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-600 transition-colors"
                >
                  <FaCopy className="mr-2" /> Copy Link
                </button>
                <button
                  onClick={shareReferralLink}
                  className="inline-flex items-center rounded-lg bg-white px-4 py-2 text-sm font-semibold text-amber-700 border border-amber-200 hover:bg-amber-50 transition-colors"
                >
                  <FaShareAlt className="mr-2" /> Share
                </button>
              </div>
            </div>
            <div className="bg-white rounded-xl px-5 py-4 min-w-[220px] shadow-sm">
              <p className="text-sm text-gray-500">Referral bonus earned</p>
              <p className="text-2xl font-bold text-gray-900">Rs {(user.referralBonusEarned || 0).toFixed(2)}</p>
              <p className="text-sm text-gray-500 mt-1">{user.referralCount || 0} successful referrals</p>
            </div>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Link
          to="/register"
          className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center"
        >
          <FaGift className="text-amber-500 text-3xl mr-4" />
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Invite Friends</h2>
            <p className="text-gray-700">Earn Rs 25 on each signup</p>
          </div>
        </Link>
        <Link
          to="/contests"
          className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center"
        >
          <FaTrophy className="text-indigo-600 text-3xl mr-4" />
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Contests</h2>
            <p className="text-gray-700">Manage contests</p>
          </div>
        </Link>
        <Link
          to="/fantasy-teams"
          className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center"
        >
          <FaUsers className="text-indigo-600 text-3xl mr-4" />
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Fantasy Teams</h2>
            <p className="text-gray-700">Manage teams</p>
          </div>
        </Link>
        <Link
          to="/matches"
          className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center"
        >
          <FaFutbol className="text-indigo-600 text-3xl mr-4" />
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Matches</h2>
            <p className="text-gray-700">Manage matches</p>
          </div>
        </Link>
        <Link
          to="/payments"
          className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center"
        >
          <FaMoneyBill className="text-indigo-600 text-3xl mr-4" />
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Payments</h2>
            <p className="text-gray-700">Manage payments</p>
          </div>
        </Link>
      </div>
    </motion.div>
  );
};

export default Dashboard;
